import ThemedDialog from 'Components/_NewElements/Dialog';
import CenteredLoadingIndicator from 'Components/CenteredLoadingIndicator';
import * as React from 'react';
import { attachmentFetchBuilder } from 'Store/messaging/fetchers/attachment';
import { TTOPIC } from 'Store/messaging/types/TTopic';
import { hasPatientData } from '.';

const AttachmentDialog = ({
  attachmentId,
  thread,
  topic,
  setOpenAttachmentId,
}: {
  attachmentId: string | null;
  thread?: IThreadListItem;
  topic?: TTOPIC;
  setOpenAttachmentId: (id: string | null) => void;
}) => {
  const [attachmentsData, setAttachmentsData] = React.useState<Blob | null>(null);

  const topicPid =
    topic?.targetPatients && hasPatientData(topic.targetPatients)
      ? topic.targetPatients[0].id
      : topic?.targetPatients[0];
  const patientId = typeof topicPid === 'string' ? topicPid : thread?.patientId;

  const attachmentFetch = () => {
    attachmentId &&
      patientId &&
      attachmentFetchBuilder<'fetch'>({
        name: 'fetch',
        queryParams: [patientId, attachmentId],
      }).then(res => {
        if (res) setAttachmentsData(res);
      });
  };

  React.useEffect(() => {
    attachmentId && attachmentFetch();
  }, [attachmentId]);

  const [toggleScaling, setToggleScaling] = React.useState<'maxWidth' | 'maxHeight'>('maxHeight');
  return (
    <ThemedDialog
      open={attachmentId !== null}
      dialogProps={{ maxWidth: 'md' }}
      dialogActions={[{ text: 'general.close', onClick: () => setOpenAttachmentId(null) }]}
      dialogActionsJustify={'center'}
      onClose={() => setOpenAttachmentId(null)}
      closeOnOutsideClick
    >
      <div style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}>
        {attachmentsData ? (
          <img
            style={{ [toggleScaling]: toggleScaling === 'maxWidth' ? '100vw' : '85vh' }}
            src={URL.createObjectURL(attachmentsData)}
            onClick={() => setToggleScaling(toggleScaling === 'maxWidth' ? 'maxHeight' : 'maxWidth')}
          />
        ) : (
          <CenteredLoadingIndicator />
        )}
      </div>
    </ThemedDialog>
  );
};

export default AttachmentDialog;
